export default [
  {
    name: "cashback",
    path: "/cashback",
    meta: {
      title: "Cashback",
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "cashback" */ "../components/main"),
  },
];
